/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-reconciliation.reducer';

export const AccountingReconciliationDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingReconciliationEntity = useAppSelector(state => state.accountingReconciliation.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingReconciliationDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingReconciliation.detail.title">AccountingReconciliation</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingReconciliationEntity.id}</dd>
          <dt>
            <span id="startDate">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.startDate">Start Date</Translate>
            </span>
            <UncontrolledTooltip target="startDate">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.startDate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.startDate}</dd>
          <dt>
            <span id="endDate">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.endDate">End Date</Translate>
            </span>
            <UncontrolledTooltip target="endDate">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.endDate" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.endDate}</dd>
          <dt>
            <span id="closingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.closingBalance">Closing Balance</Translate>
            </span>
            <UncontrolledTooltip target="closingBalance">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.closingBalance" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.closingBalance}</dd>
          <dt>
            <span id="difference">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.difference">Difference</Translate>
            </span>
            <UncontrolledTooltip target="difference">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.difference" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.difference}</dd>
          <dt>
            <span id="reconciled">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.reconciled">Reconciled</Translate>
            </span>
            <UncontrolledTooltip target="reconciled">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.reconciled" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.reconciled ? 'true' : 'false'}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingReconciliation.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingReconciliationEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingReconciliation.account">Account</Translate>
          </dt>
          <dd>{accountingReconciliationEntity.account ? accountingReconciliationEntity.account.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingReconciliation.transaction">Transaction</Translate>
          </dt>
          <dd>
            {accountingReconciliationEntity.transactions
              ? accountingReconciliationEntity.transactions.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingReconciliationEntity.transactions && i === accountingReconciliationEntity.transactions.length - 1
                      ? ''
                      : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/accounting-reconciliation" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-reconciliation/${accountingReconciliationEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingReconciliationDetail;
